import { css } from "@emotion/react";

export const InputDisplayValue = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div
      css={css`
        position: absolute;
        top: 0px;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        font: inherit;
        line-height: inherit;
        color: inherit;
        text-overflow: ellipsis;
        white-space: nowrap;
        pointer-events: none;
        isolation: isolate;
      `}
    >
      {children}
    </div>
  );
};
